import { createSlice } from '@reduxjs/toolkit';
import { IProfileContainer } from '../models/Profile/IProfileContainer';
import { IProfilePhoto } from '../models/Profile/IProfilePhoto';
import type { RootState } from './store';

interface ProfileState {
  profileContainer: IProfileContainer;
  profilePhoto: IProfilePhoto;
}

const initialState: ProfileState = {
  profileContainer: null,
  profilePhoto: null,
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profileContainer = action.payload;
    },
    setProfilePhoto: (state, action) => {
      state.profilePhoto = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setProfile, setProfilePhoto } = profileSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
export const selectProfile = (state: RootState) => state.profileReducer.profileContainer;

export default profileSlice.reducer;
